import React from 'react';

import Authenticated from 'Components/Layouts/Authenticated';
import Container from "Components/Utilities/Container";

export default class About extends React.Component {
    render() {
        return (
            <Authenticated title="Dashboard">
                <div className="py-10 lg:py-20">
                    <div className="text-3xl text-app-blue font-bold text-center mb-10 lg:mb-20">
                        About Bupa
                    </div>

                    <Container size="max-w-4xl">
                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-20">
                            <div className="space-y-6 text-xl text-app-blue">
                                <p>
                                    Since our inception in 1947, Bupa has grown to be a healthcare company serving over
                                    50 million customers worldwide.
                                </p>
                                <p>
                                    From early years through to retirement, we're privileged to be a part of millions of
                                    lives around the world.
                                </p>
                                <p>
                                    With no shareholders, our customers are our focus. We reinvest profits into
                                    providing more and better healthcare for the benefit of current and future
                                    customers.
                                </p>
                                <p>
                                    Health insurance is at the core of our business and we provide healthcare through
                                    our health clinics, digital services, hospitals, dental centres and aged care
                                    facilities.
                                </p>
                                <p>
                                    The breadth and depth of our experience gives us greater insight into how health
                                    systems work in the markets in which we have a presence, enabling us to better meet
                                    the diverse needs of our customers.
                                </p>
                            </div>

                            <div className="bg-app-gray flex flex-col justify-between p-6 lg:p-8 space-y-6 lg:space-y-0">
                                <div>
                                    <p className="text-3xl lg:text-5xl text-app-light-blue font-bold">
                                        50m
                                    </p>
                                    <p>
                                        Over 50 million customers worldwide.
                                    </p>
                                </div>

                                <div>
                                    <p className="text-3xl lg:text-5xl text-app-light-blue font-bold">
                                        29.7m
                                    </p>
                                    <p>
                                    We have around 29.7m health insurance customers worldwide.
                                    </p>
                                </div>

                                <div>
                                    <p className="text-3xl lg:text-5xl text-app-light-blue font-bold">
                                        20.3m
                                    </p>
                                    <p>
                                    We are also a health provider, serving around 20.3m people globally in our
                                        health clinics, hospitals and dental centres.
                                    </p>
                                </div>

                                <div>
                                    <p className="text-3xl lg:text-5xl text-app-light-blue font-bold">
                                        20,846
                                    </p>
                                    <p>
                                    We also care for around 20,846 residents in our aged care businesses in the UK,
                                        Australia, New Zealand
                                        and Spain.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </Container>
                </div>
            </Authenticated>
        );
    }
}
